import {EventEmitter, Injectable} from '@angular/core';
import {NotificationType} from './notification-type.enum';
import {Notification} from './notification';

@Injectable()
export class NotifierService {

  public notification = new EventEmitter<Notification>();

  public notify(notificationType: NotificationType, message: String) {
    this.notification.emit({notificationType, message})
  };

  constructor() { }

}
